import RightsCategoryBuilder from "../models/builders/RightsCategoryBuilder";
import SubrightBuilder from "../models/builders/SubrightBuilder";
import LearnMoreBuilder from "../models/builders/LearnMoreBuilder";
import OrganizationBuilder from "../models/builders/OrganizationBuilder";
import {
  getDatabase,
  ref,
  query,
  get,
  orderByChild,
  equalTo,
} from "firebase/database";

const kTranslation = "translation";
const kRightsCategory = "rights-categories";
const kSubrights = "subrights";
const kLearnMores = "learn-mores";
const kOrganizations = "organizations";
const kRightsCategoryID = "rightsCategoryID";
const kSubrightID = "subrightID";

const fetchTranslations = () => {
  return new Promise((resolve, reject) => {
    const translationRef = ref(getDatabase(), kTranslation);
    get(translationRef)
      .then((dataSnapshot) => {
        let hashToPhrase = {};
        dataSnapshot.forEach(function (data) {
          hashToPhrase[data.key] = data.val()["en"];
        });
        resolve(hashToPhrase);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const fetchRightsCategoriesNew = () => {
  return new Promise((resolve, reject) => {
    const rightsCategoriesRef = ref(getDatabase(), kRightsCategory);
    get(rightsCategoriesRef)
      .then((dataSnapshot) => {
        const rightsCategories = [];
        dataSnapshot.forEach((child) => {
          const category = RightsCategoryBuilder.buildRightsCategory(
            child.val().description,
            child.key,
            child.val().image,
            child.val().subtitle,
            child.val().title
          );
          if (category != null) {
            rightsCategories.push(category);
          }
        });
        resolve(rightsCategories);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const fetchSubrightsNew = (rightsCategoryID) => {
  return new Promise((resolve, reject) => {
    const queryValue = rightsCategoryID;
    const subrightRef = query(
      ref(getDatabase(), kSubrights),
      orderByChild(kRightsCategoryID),
      equalTo(queryValue)
    );
    get(subrightRef)
      .then((dataSnapshot) => {
        const subRights = [];
        dataSnapshot.forEach((child) => {
          const subright = SubrightBuilder.buildSubright(
            child.val().rightsCategoryID,
            child.val().description,
            child.key,
            child.val().learnMores,
            child.val().organizations,
            child.val().title
          );
          if (subright != null) {
            subRights.push(subright);
          }
        });
        resolve(subRights);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const fetchLearnMoresNew = (subrightID) => {
  return new Promise((resolve, reject) => {
    const learnMoreRef = query(
      ref(getDatabase(), kLearnMores),
      orderByChild(kSubrightID),
      equalTo(subrightID)
    );
    get(learnMoreRef)
      .then((dataSnapshot) => {
        const learnMores = [];
        dataSnapshot.forEach((child) => {
          const learnMore = LearnMoreBuilder.buildLearnMore(
            child.key,
            child.val().informationChunks,
            child.val().title,
            child.val().subrightID
          );
          if (learnMore != null) {
            learnMores.push(learnMore);
          }
        });
        resolve(learnMores);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const fetchOrgs = () => {
  return new Promise((resolve, reject) => {
    const orgRef = ref(getDatabase(), `${kOrganizations}`);
    get(orgRef)
      .then((dataSnapshot) => {
        const orgsTemp = [];
        dataSnapshot.forEach((child) => {
          const org = OrganizationBuilder.buildOrganization(
            child.key,
            child.val().abbrev,
            child.val().addresses,
            child.val().description,
            child.val().image,
            child.val().name,
            child.val().website
          );
          if (org != null) {
            orgsTemp.push(org);
          }
        });
        const orgs = orgsTemp.filter((org) => org != null);
        resolve(orgs);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export {
  fetchTranslations,
  fetchRightsCategoriesNew,
  fetchSubrightsNew,
  fetchLearnMoresNew,
  fetchOrgs,
};
